import { ChatConversationDao } from '@rock/db-admin';
import type { ChatConversationId, UserId } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atomFamily } from 'jotai/utils';

const dao = new ChatConversationDao();

/** A user's most recent chat conversations, newest activity first. */
export const conversationsForUserState = atomFamily(
    (userId: UserId | undefined) => dao.conversationsAtom(userId),
    shallowEqual,
);

/** One conversation, messages included — the transcript viewer's whole data source. */
export const conversationState = atomFamily(
    (params: { userId: UserId; conversationId: ChatConversationId } | undefined) => dao.conversationAtom(params),
    shallowEqual,
);
